const SUMAR_ROUTE_NAMES = [
  'pripadSumar',
  'pripadSumarNajomca',
  'pripadSumarDodatInfo',
];

function isSumarRoute(route) {
  return SUMAR_ROUTE_NAMES.includes(route?.name);
}

function isSumarRouteNormalization(to, from) {
  const toNewId = to?.params?.new_id;
  const fromNewId = from?.params?.new_id;

  return (
    to?.name === 'pripadSumar' &&
    ['pripadSumarNajomca', 'pripadSumarDodatInfo'].includes(from?.name) &&
    !!toNewId &&
    toNewId === fromNewId
  );
}

function getRouteViewKey(route) {
  return isSumarRoute(route) ? 'pripadSumar' : route?.name;
}

function getNormalizedSumarRoute(route) {
  const query = { ...(route?.query ?? {}) };
  delete query.kontrola;

  return {
    name: 'pripadSumar',
    params: { new_id: route?.params?.new_id },
    query,
    hash: route?.hash,
  };
}

module.exports = {
  getNormalizedSumarRoute,
  getRouteViewKey,
  isSumarRouteNormalization,
};
